<div class="flex flex-col gap-[1rem] items-start w-full">
  <!-- Header -->
  <div class="flex items-center justify-center md:justify-between w-full">
    <div class="flex gap-[1rem] items-center">
      <h2 class="font-bold text-[1.1875rem] md:text-[1.375rem] leading-[1.6] text-[#222528]">
        {{ 'dashboard.featuredRewards' | translate }}
      </h2>
    </div>
    <a
      data-testid="featured-rewards-view-all"
      routerLink="/workspace/rewards/featured"
      class="hidden gap-[0.5rem] items-center no-underline md:flex"
    >
      <span class="font-light text-[1.125rem] leading-[1.6] text-[#007dcb]">
        {{ 'rewards.viewAll' | translate }}
      </span>
      <img
        src="assets/img/dashboard-v2/view-all-chevron.svg"
        alt=""
        aria-hidden="true"
        class="size-6 shrink-0 rotate-180 object-scale-down"
      />
    </a>
  </div>

  @if (featuredIsLoading()) {
    <div class="flex items-center justify-center w-full py-[2rem] relative min-h-[5rem]">
      <korviu-loader></korviu-loader>
    </div>
  } @else if (lessThan500Ganas) {
    <div class="flex flex-col gap-[1rem] w-full">
      <!-- Reward Cards Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-[1rem] w-full">
        @for (product of localizedFeatured(); track product.id) {
          <div
            class="bg-white border border-[#eeeeef] rounded-[0.5rem] min-h-[6.5rem] px-[1rem] py-[1.25rem] flex gap-[1.5rem] items-center cursor-pointer"
            (click)="navigateToProduct(product.id)"
          >
            <div class="flex-1 flex gap-[1rem] items-center min-w-0">
              <img
                [src]="product.image"
                [alt]="product.displayName"
                class="bg-[#eeeeef] rounded-[0.25rem] w-[4rem] h-[4rem] shrink-0 object-cover"
              />
              <div class="flex-1 flex flex-col gap-[0.5rem] min-w-0">
                <div class="flex flex-col w-full">
                  <p class="font-bold text-[1.125rem] leading-[1.6] text-[#393e44] truncate w-full">
                    {{ product.displayName }}
                  </p>
                </div>
                <div class="flex gap-[0.5rem] items-center w-full">
                  <div class="flex gap-[0.25rem] items-center text-[0.9375rem] leading-[1.6]">
                    <p class="font-bold text-[#017f70]">{{ product.price_ganas }}</p>
                    <p class="font-medium text-[#505760]">{{ 'rewards.ganas' | translate }}</p>
                  </div>
                </div>
              </div>
            </div>
            <button
              class="size-[1.5rem] flex items-center justify-center shrink-0"
              (click)="toggleFavorite($event, product)"
            >
              @if (product.is_favorite) {
                <i>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                    <path
                      d="M10.8197 1.57717L9.99895 2.39968L9.17565 1.57643C7.07663 -0.522643 3.67336 -0.522643 1.5743 1.57643C-0.524768 3.67549 -0.524768 7.07875 1.5743 9.17785L9.46965 17.0731C9.76255 17.366 10.2375 17.366 10.5304 17.0731L18.4318 9.17635C20.5262 7.07035 20.5298 3.67662 18.4304 1.57717C16.3275 -0.525723 12.9226 -0.525723 10.8197 1.57717Z"
                      fill="#E53935"
                    />
                  </svg>
                </i>
              } @else {
                <i>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                    <path
                      d="M10.8197 1.57717L9.99895 2.39968L9.17565 1.57643C7.07663 -0.522643 3.67336 -0.522643 1.5743 1.57643C-0.524768 3.67549 -0.524768 7.07875 1.5743 9.17785L9.46965 17.0731C9.76255 17.366 10.2375 17.366 10.5304 17.0731L18.4318 9.17635C20.5262 7.07035 20.5298 3.67662 18.4304 1.57717C16.3275 -0.525723 12.9226 -0.525723 10.8197 1.57717ZM17.3682 8.11865L9.99995 15.4822L2.63496 8.11715C1.12167 6.60385 1.12167 4.15037 2.63496 2.63709C4.14824 1.1238 6.60175 1.1238 8.11505 2.63709L9.47245 3.99453C9.77035 4.2924 10.2551 4.28659 10.5457 3.98168L11.8804 2.63783C13.3975 1.12073 15.8526 1.12073 17.3697 2.63783C18.8834 4.15148 18.8808 6.59775 17.3682 8.11865Z"
                      fill="#505760"
                    />
                  </svg>
                </i>
              }
            </button>
          </div>
        }
      </div>
    </div>
  } @else {
    @let hero = localizedFeatured()[0];
    @if (hero) {
      <!-- Featured Card (hero) -->
      <div
        class="flex flex-col h-[20.4375rem] w-full rounded-br-[5.5rem] cursor-pointer"
        (click)="navigateToProduct(hero.id)"
      >
        <!-- Image Section -->
        <div
          class="flex-1 bg-[#eeeeef] rounded-t-[0.5rem] p-[1rem] flex items-start justify-between relative overflow-hidden"
        >
          @if (hero.is_limited_time_offer) {
            <div
              class="bg-[#e5fff0] border border-[#32e479] rounded-[0.25rem] px-[0.5rem] py-[0.125rem] flex gap-[0.5rem] items-center justify-center z-10"
            >
              <p class="text-[0.8125rem] md:text-[0.9375rem] leading-[1.6] text-[#00401a]">
                {{ 'dashboard.limitedTimeOffer' | translate }}
              </p>
            </div>
          }
          <button
            class="w-[2.5rem] h-[2.5rem] flex items-center justify-center z-10 ml-auto"
            (click)="toggleFavorite($event, hero)"
          >
            @if (hero.is_favorite) {
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                  <path
                    d="M10.8197 1.57717L9.99895 2.39968L9.17565 1.57643C7.07663 -0.522643 3.67336 -0.522643 1.5743 1.57643C-0.524768 3.67549 -0.524768 7.07875 1.5743 9.17785L9.46965 17.0731C9.76255 17.366 10.2375 17.366 10.5304 17.0731L18.4318 9.17635C20.5262 7.07035 20.5298 3.67662 18.4304 1.57717C16.3275 -0.525723 12.9226 -0.525723 10.8197 1.57717Z"
                    fill="#E53935"
                  />
                </svg>
              </i>
            } @else {
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12.8197 4.57717L11.999 5.39968L11.1757 4.57643C9.07663 2.47736 5.67336 2.47736 3.5743 4.57643C1.47523 6.67549 1.47523 10.0787 3.5743 12.1778L11.4697 20.0731C11.7626 20.366 12.2375 20.366 12.5304 20.0731L20.4318 12.1763C22.5262 10.0703 22.5298 6.67662 20.4304 4.57717C18.3275 2.47428 14.9226 2.47428 12.8197 4.57717ZM19.3682 11.1186L12 18.4822L4.63496 11.1171C3.12167 9.60385 3.12167 7.15037 4.63496 5.63709C6.14824 4.1238 8.60175 4.1238 10.1151 5.63709L11.4725 6.99453C11.7704 7.2924 12.2551 7.28659 12.5457 6.98168L13.8804 5.63783C15.3975 4.12073 17.8526 4.12073 19.3697 5.63783C20.8834 7.15148 20.8808 9.59775 19.3682 11.1186Z"
                    fill="#505760"
                  />
                </svg>
              </i>
            }
          </button>
          <!-- Actual image -->
          <img class="absolute inset-0 w-full h-full object-cover" [src]="hero.image" [alt]="hero.displayName" />
        </div>

        <!-- Info Section -->
        <div
          class="bg-white border border-t-0 border-[#c9cbce] rounded-b-[0.5rem] px-[1.5rem] py-[1rem] flex flex-col gap-[0.5rem]"
        >
          <div class="flex flex-col gap-[1rem] w-full">
            <div class="flex flex-col gap-[0.25rem] w-full">
              <p class="font-bold text-[1.1875rem] md:text-[1.375rem] leading-[1.6] text-[#222528] truncate w-full">
                {{ hero.displayName }}
              </p>
            </div>
            <div class="flex gap-[1rem] items-center w-full">
              <div
                class="bg-[#e6f2f1] rounded-[0.5rem] p-[0.5rem] w-[2.5rem] h-[2.5rem] flex gap-[0.5rem] items-center justify-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="30" viewBox="0 0 20 30" fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.0536 27.3373C15.0149 24.5823 17.8621 19.5891 17.8621 14.3853C17.8621 11.6498 17.0008 9.54344 15.6629 8.13584C14.3329 6.73659 12.3888 5.87499 9.91052 5.87499C7.40177 5.87499 5.46262 6.70197 4.14795 8.06443C2.82825 9.43211 1.95897 11.5261 1.95897 14.3853C1.95897 19.589 4.80641 24.5823 9.7675 27.3373C9.85661 27.3868 9.96449 27.3868 10.0536 27.3373ZM11.0046 29.0499C16.5775 25.9553 19.821 20.3126 19.821 14.3853C19.821 8.08016 15.8226 3.91602 9.91052 3.91602C3.99849 3.91602 0 7.86133 0 14.3853C0 20.3126 3.24385 25.9553 8.81644 29.0499C9.49703 29.4279 10.324 29.4279 11.0046 29.0499Z"
                    fill="#017F70"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.2506 0.18339C11.6903 0.498485 11.7914 1.11038 11.4763 1.55009C10.9158 2.33221 10.5971 3.44084 10.5167 4.63668C10.4367 5.82713 10.6007 6.99603 10.9003 7.83196C11.0828 8.34119 10.818 8.90197 10.3088 9.08451C9.79953 9.26704 9.23875 9.0022 9.05622 8.49297C8.65366 7.36992 8.46663 5.92686 8.56215 4.50534C8.65731 3.08923 9.0406 1.58588 9.88392 0.409031C10.199 -0.0306822 10.8109 -0.131705 11.2506 0.18339Z"
                    fill="#017F70"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.01123 13.7909C7.59643 14.3034 7.34242 15.0754 7.34242 16.0294C7.34242 16.9835 7.59643 17.7554 8.01123 18.2679C8.4044 18.7537 9.00379 19.087 9.91059 19.087C10.8174 19.087 11.4168 18.7537 11.8099 18.2679C12.2247 17.7554 12.4788 16.9835 12.4788 16.0294C12.4788 15.0754 12.2247 14.3034 11.8099 13.7909C11.4168 13.3052 10.8174 12.9718 9.91059 12.9718C9.00379 12.9718 8.4044 13.3052 8.01123 13.7909ZM6.48762 12.5578C7.27719 11.5822 8.4519 11.0117 9.91059 11.0117C11.3693 11.0117 12.544 11.5822 13.3335 12.5578C14.1015 13.5066 14.4388 14.7535 14.4388 16.0294C14.4388 17.3053 14.1015 18.5522 13.3335 19.501C12.544 20.4766 11.3693 21.0471 9.91059 21.0471C8.4519 21.0471 7.27719 20.4766 6.48762 19.501C5.71968 18.5522 5.38232 17.3053 5.38232 16.0294C5.38232 14.7535 5.71968 13.5066 6.48762 12.5578Z"
                    fill="#017F70"
                  />
                </svg>
              </div>
              <p class="font-bold text-[1.75rem] md:text-[1.9375rem] leading-[1.4] text-[#017f70]">
                {{ hero.price_ganas }} {{ 'rewards.ganas' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Reward List (rest) -->
      <div class="flex flex-col gap-[1rem] w-full">
        @for (product of remainingFeatured(); track product.id) {
          <div
            class="bg-white border border-[#eeeeef] rounded-[0.5rem] px-[1rem] py-[1.25rem] flex flex-col md:items-center md:flex-row gap-[1.5rem] md:gap-[0.5rem] cursor-pointer"
            (click)="navigateToProduct(product.id)"
          >
            <div class="flex gap-[1.5rem] items-center w-full min-w-0">
              <div class="flex-1 flex gap-[1rem] items-center min-w-0">
                <img
                  class="bg-[#eeeeef] rounded-[0.25rem] w-[4rem] h-[4rem] shrink-0 object-cover"
                  [src]="product.image"
                  [alt]="product.displayName"
                />
                <div class="flex-1 flex flex-col gap-[0.5rem] min-w-0">
                  <div class="flex flex-col w-full">
                    <p class="font-bold text-[1.125rem] leading-[1.6] text-[#393e44] truncate w-full">
                      {{ product.displayName }}
                    </p>
                  </div>
                  <div class="flex gap-[0.5rem] items-center w-full">
                    <div class="flex gap-[0.25rem] items-center text-[0.9375rem] leading-[1.6]">
                      <p class="font-bold text-[#017f70]">{{ product.price_ganas }}</p>
                      <p class="font-medium text-[#505760]">{{ 'rewards.ganas' | translate }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex gap-[1rem] items-center shrink-0">
                <button
                  class="w-[1.5rem] h-[2rem] flex items-center justify-center shrink-0"
                  (click)="toggleFavorite($event, product)"
                >
                  @if (product.is_favorite) {
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                        <path
                          d="M10.8197 1.57717L9.99895 2.39968L9.17565 1.57643C7.07663 -0.522643 3.67336 -0.522643 1.5743 1.57643C-0.524768 3.67549 -0.524768 7.07875 1.5743 9.17785L9.46965 17.0731C9.76255 17.366 10.2375 17.366 10.5304 17.0731L18.4318 9.17635C20.5262 7.07035 20.5298 3.67662 18.4304 1.57717C16.3275 -0.525723 12.9226 -0.525723 10.8197 1.57717Z"
                          fill="#E53935"
                        />
                      </svg>
                    </i>
                  } @else {
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12.8197 4.57717L11.999 5.39968L11.1757 4.57643C9.07663 2.47736 5.67336 2.47736 3.5743 4.57643C1.47523 6.67549 1.47523 10.0787 3.5743 12.1778L11.4697 20.0731C11.7626 20.366 12.2375 20.366 12.5304 20.0731L20.4318 12.1763C22.5262 10.0703 22.5298 6.67662 20.4304 4.57717C18.3275 2.47428 14.9226 2.47428 12.8197 4.57717ZM19.3682 11.1186L12 18.4822L4.63496 11.1171C3.12167 9.60385 3.12167 7.15037 4.63496 5.63709C6.14824 4.1238 8.60175 4.1238 10.1151 5.63709L11.4725 6.99453C11.7704 7.2924 12.2551 7.28659 12.5457 6.98168L13.8804 5.63783C15.3975 4.12073 17.8526 4.12073 19.3697 5.63783C20.8834 7.15148 20.8808 9.59775 19.3682 11.1186Z"
                          fill="#505760"
                        />
                      </svg>
                    </i>
                  }
                </button>
              </div>
            </div>
            <korviu-button (click)="$event.stopPropagation()" (onclick)="navigateToProduct(product.id)"
              ><p class="text-[1.125rem] leading-[1.6] text-white">{{ 'rewards.redeem' | translate }}</p></korviu-button
            >
          </div>
        }
      </div>
    }
  }
  <div class="flex gap-[0.5rem] items-center block md:hidden mx-auto">
    <button type="button" class="font-light text-[1.125rem] leading-[1.6] text-[#007dcb]" (click)="onViewAllClick()">
      {{ 'rewards.viewAll' | translate }}
    </button>
  </div>
</div>
